import {Grid, styled} from "@material-ui/core";


export const GridDivider = styled(Grid)((p) => ({
  [p.theme.breakpoints.up("md")]: {
    borderRight: "1px solid rgba(0, 0, 0, 0.12);",
  },
}));
